export class CandidateSet {
  id: string;
  candidateId: number;
  setId: number;
  enabled: boolean;

  constructor() { }
}
